//Validation which is too complicated for VeeValidate or doesn't work properly with it is stored here
export const manualValidationMixin = {
  methods: {
    //checks if in several select forms the same option was selected more than once
    SelectedSameOption(input) {
      const selectedOptions = []

      for (let i = 0; i < input.length; i++) {
        if (input[i].selectedOption !== null) {
          selectedOptions.push(input[i].selectedOption.value)
        }
      }

      if (selectedOptions.length > 0) {
        return this.arrayHasDuplicates(selectedOptions)
      }

      return false
    }
  }
}
